import { AnnualEnrollmentStatus } from '../../../../global/models/annual-enrollment-status-model';
import { ApiStatuses } from '../../../../global/models/api-model';
import { DemographicAppKeys } from '../../../../global/models/demographics-model';
import { Person } from '../../../../global/models/person-model';
import { AddressFields } from '../../models/form-models';

export enum CpgUserTypes {
    ACTIVE_LAY = 'ACTIVE_LAY',
    ACTIVE_CLERGY = 'ACTIVE_CLERGY',
    RETIRED_LAY = 'RETIRED_LAY',
    RETIRED_CLERGY = 'RETIRED_CLERGY',
}

export interface PersonalInfoAppState {
    [DemographicAppKeys.myCPG]: PersonalInfoState;
    [DemographicAppKeys.arc]: PersonalInfoState;
}

export interface PersonalInfoState {
    currentPerson: Person,
    setPersonFailed: boolean,
    loggedInAsAdmin: boolean,
    showPublishedAddressUpdate: boolean,
    pendingUpdateObject: any,
    newMailingAddress: AddressFields
    patchPersonStatus: ApiStatuses,
    annualEnrollmentStatus: AnnualEnrollmentStatus,
    setAnnualEnrollmentStatusFailed: boolean,
}

export enum PersonalInfoActionTypes {
    SET_PERSON_INFO = 'SET_PERSON_INFO',
    SET_PERSON_FAIL = 'SET_PERSON_FAIL',
    SET_ADMIN = 'SET_ADMIN',
    FAKE_CLERGY = 'FAKE_CLERGY',
    TOGGLE_PUBLISHED_ADDRESS = 'TOGGLE_PUBLISHED_ADDRESS',
    PATCH_PERSON_STATUS = 'PATCH_PERSON_STATUS',
    SET_PERSONAL_INFO_CLIENT_NUMBER = 'SET_PERSONAL_INFO_CLIENT_NUMBER',
    UNLOAD_PERSON_STATE = 'UNLOAD_PERSON_STATE',
    SET_ANNUAL_ENROLLMENT_STATUS = 'SET_ANNUAL_ENROLLMENT_STATUS',
    SET_ANNUAL_ENROLLMENT_STATUS_FAIL = 'SET_ANNUAL_ENROLLMENT_STATUS_FAIL',
}

export enum PersonalInfoPersonTypes {
    Member = 'Member',
    Spouse = 'Spouse',
    Child = 'Child',
    DomesticPartner = 'DomesticPartner',
}

export enum PersonalUpdateStatus {
    MARTIAL_STATUS = 'MARITAL_STATUS',
}